// extracted by mini-css-extract-plugin
export var downArrow = "_b8-0";
export var label = "_b8-1";
export var treatmentCard = "_b8-3";
export var upArrow = "_b8-2";